import React from "react";
import MultiSelect from "../../../components-react/MultiSelect";
import { AlertIcon } from "../../../../images/icons/icons";

const FormMultiSelect = ({
  icon: Icon,
  label,
  name,
  options,
  state,
  setState,
  error,
  disabled = false,
  required = false,
  onRef,
  className = "",
}) => {
  const hasValue = (value) => {
    if (Array.isArray(value)) return value.length > 0;
    return false;
  };

  return (
    <div className={`staff-onboarding-form-group span4 ${className}`}>
      <label className="staff-onboarding-form-label">
        {Icon && <Icon color="#6B7280" />}
        <span className="staff-onboarding-label-text">
          {label}{" "}
          {required && <span className="staff-onboarding-required">*</span>}
        </span>
      </label>

      <div
        className={`staff-onboarding-multiselect-wrapper ${
          error ? "error" : ""
        } ${disabled ? "disabled" : ""} ${hasValue(state) ? "has-value" : ""}`}
        ref={onRef}
      >
        <MultiSelect
          options={options?.length > 0 ? options : []}
          state={state}
          setState={setState}
          isDisable={disabled}
          isShowList={true}
        />
        {error && (
          <div className="staff-onboarding-error-message">
            <AlertIcon color="#EF4444" />
            <span>{error}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default FormMultiSelect;
